// extracted by mini-css-extract-plugin
module.exports = {"Branding":"branding_Branding__dYwFR","topMargin":"branding_topMargin__ljZP8"};